import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TablePagination from "./pagination";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import StatusChip from "./chip";

const BasicTable = ({
  columns,
  rows,
  showStatus,
  showAction,
  onStatusChange,
  onEditClick,
  onDeleteClick,
  paginated,
}) => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  const handlePageChange = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setPage(1);
  };
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(1);
  };

  const filteredRows = rows.filter((row) =>
    Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <>
      <Box mb={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <TextField
          variant="outlined"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            style: {
              borderRadius: "30px",
              backgroundColor: "#F9FAFB",
            },
          }}
          sx={(theme) => ({
            width: "100%",
            maxWidth: "250px",
            borderRadius: "32px",
            color: "#FAFAFA",
            backgroundColor: "#FAFAFA",
            border: `1px solid ${theme.palette.BudgieThemeColor.Neutrals[300]}`,
            "& .MuiOutlinedInput-root": {
              padding: "0px",
              height: "35px",
              borderRadius: "32px",
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.palette.BudgieThemeColor.Neutrals[100],
              },
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.BudgieThemeColor.Neutrals[100],
            },
          })}
        />
      </Box>

      <TableContainer
        sx={{ boxShadow: "none", borderRadius: "0px", overflowX: "auto" }}
        component={Paper}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>S.no</TableCell>
              {columns.map((column) => (
                <TableCell key={column.field}>{column.headerName}</TableCell>
              ))}
              {showStatus && <TableCell>Status</TableCell>}
              {showAction && <TableCell>Action</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((row, index) => (
              <TableRow key={row.id || index}>
                <TableCell>
                  {String((page - 1) * rowsPerPage + index + 1).padStart(
                    2,
                    "0"
                  )}
                </TableCell>
                {columns.map((column, cellIndex) => (
                  <TableCell key={cellIndex}>
                    {column.renderCell ? (
                      column.renderCell({ value: row[column.field], row })
                    ) : //  : column.field === "logo" ? (
                    //   <Avatar alt={row[column.field]} src={row.logoValue} />
                    // )
                    column.field === "parentOrganization" ? (
                      <>{row[column.field].organizationDetail}</>
                    ) : column.field === "organizationMapping" ? (
                      <ul style={{ padding: 0, margin: 0 }}>
                        {row[column.field]?.map((org, i) => (
                          <li
                            key={i}
                            style={{
                              listStyle: "none",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <span style={{ marginRight: "5px" }}>•</span>{" "}
                            {org.organizationDetail}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      row[column.field]
                    )}
                  </TableCell>
                ))}
                {showStatus && (
                  <TableCell>
                    <StatusChip
                      label={row.status === "Active" ? "Active" : "Inactive"}
                      colorchip={row.status === "Active" ? "#17B26A" : "red"}
                      backgroundColor={
                        row.status === "Active" ? "#ECFDF3" : "#FEF3F2"
                      }
                      dotColor={row.status === "Active" ? "#17B26A" : "#F04438"}
                      borderColor={
                        row.status === "Active" ? "#ABEFC6" : "#FECDCA"
                      }
                    />
                  </TableCell>
                )}
                {showAction && (
                  <TableCell>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <InfoOutlinedIcon
                        sx={{ color: "#D8D8D8", cursor: "pointer" }}
                        onClick={() => onStatusChange(row)}
                      />
                      <EditIcon
                        sx={{ color: "#D8D8D8", cursor: "pointer" }}
                        onClick={() => onEditClick(row)}
                      />
                      <DeleteIcon
                        sx={{ color: "#D8D8D8", cursor: "pointer" }}
                        onClick={() => onDeleteClick(row)}
                      />
                    </Stack>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {paginated && (
        <TablePagination
          page={page}
          rowsPerPage={rowsPerPage}
          totalRows={filteredRows.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}
    </>
  );
};

export default BasicTable;
